import { Delete } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { number as fmtNumber } from '@/lib/format';
import { cn } from '@/lib/utils';

interface NumberPadProps {
  value: number;
  onChange: (value: number) => void;
  /** Show quick-cash chips (50k/100k/150k) — for cash tendered. */
  cashChips?: boolean;
  className?: string;
}

const CHIPS = [50000, 100000, 150000, 200000];

/** Full numeric keypad — huge keys for qty / cash tendered. */
export function NumberPad({ value, onChange, cashChips, className }: NumberPadProps) {
  const push = (digit: string) => {
    const next = Number(`${value}${digit}`);
    if (Number.isFinite(next)) onChange(next);
  };
  const backspace = () => {
    const str = String(value);
    const next = str.length <= 1 ? 0 : Number(str.slice(0, -1));
    onChange(Number.isFinite(next) ? next : 0);
  };
  const clear = () => onChange(0);

  return (
    <div className={cn('flex flex-col gap-3', className)}>
      {cashChips && (
        <div className="grid grid-cols-4 gap-2">
          {CHIPS.map((c) => (
            <Button
              key={c}
              variant="secondary"
              size="sm"
              className="tnum h-11 font-display"
              onClick={() => onChange(c)}
            >
              {fmtNumber(c / 1000)}k
            </Button>
          ))}
        </div>
      )}
      <div className="grid grid-cols-3 gap-2.5">
        {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((d) => (
          <Button
            key={d}
            variant="outline"
            size="iconLg"
            className="tnum h-16 w-full font-display text-2xl"
            onClick={() => push(d)}
          >
            {d}
          </Button>
        ))}
        <Button
          variant="outline"
          size="iconLg"
          className="h-16 w-full text-base"
          onClick={clear}
        >
          C
        </Button>
        <Button
          variant="outline"
          size="iconLg"
          className="tnum h-16 w-full font-display text-2xl"
          onClick={() => push('0')}
        >
          0
        </Button>
        <Button
          variant="outline"
          size="iconLg"
          className="h-16 w-full"
          onClick={backspace}
          aria-label="Hapus satu digit"
        >
          <Delete className="h-6 w-6" />
        </Button>
      </div>
    </div>
  );
}
